import styled from "styled-components";

export const PrimaryActionButtonForModal = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  padding: 6px 14px;   
  height: 27px;        

    background: #3a87c8;
  color: #ffffff;

  border: none;
  border-radius: 15px;

  font-size: 14px;
  font-weight: 400;

  cursor: pointer;
  user-select: none;
  outline: none;

  flex-shrink: 0;      

  transition: background-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
      background-color: #0069d9
  }

  &:focus-visible {
  }

    &:focus {
        outline: none;
        box-shadow: none;
    }
`;

export const PrimaryActionButtonForPage = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  padding: 14px 22px;   
  height: 30px;        

  background: #3a87c8;
  color: #ffffff;

  border: none;
  border-radius: 15px;

  font-size: 15px;
  font-weight: 400;

  cursor: pointer;
  user-select: none;
  outline: none;

  flex-shrink: 0;      

  transition: background-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
      background-color: #0069d9
  }

  &:focus-visible {
  }

    &:focus {
        outline: none;
        box-shadow: none;
    }
`;

export const CustomModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 15px 5px 0px 0px;
    border-top: 1px solid #dee2e6;
`;

export const TooltipWrapper = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    padding: 6px; 

    cursor: pointer;

    font-size: 20px; 
    color: #555; 

    &:after {
        content: "${props => props.message}";
        position: absolute;

        top: 50%; 
        left: 100%;
        transform: translateY(-50%) translateX(10px) scale(0); 

        padding: 10px 14px; 
        border-radius: 8px; 

        background-color: #333;
        color: white;
        font-size: 13px; 
        white-space: nowrap; 

        opacity: 0;
        visibility: hidden; 
        z-index: 100; 
        box-shadow: 0 4px 10px rgba(0,0,0,0.15);
        transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    }

    &:before {
        content: "";
        position: absolute;

        top: 50%;
        left: 100%;
        transform: translateY(-50%) translateX(-1px) scale(0); 

        border-width: 6px;
        border-style: solid;
        border-color: transparent #333 transparent transparent; 

        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    }

    &:hover:after,
    &:hover:before {
        opacity: 1;
        visibility: visible;

        transform: translateY(-50%) translateX(10px) scale(1);
    }
`;


